import { render, staticRenderFns } from "./Drone.vue?vue&type=template&id=18b4b1de&"
import script from "./Drone.vue?vue&type=script&lang=js&"
export * from "./Drone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports